module.exports = __webpack_public_path__ + "static/media/corporate-services-img83.2bee0af9.jpg";